import { NoticeLoginApp } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { splitNoticesByPlacement } from './splitNoticesByPlacement';

type Options = {
  /** Customer login narrows by brand. Omitted for partner and admin. */
  brandId?: number;
  /** False while the caller is still resolving an input the query needs. */
  enabled?: boolean;
};

/** Login-page notices. No app means the screen does not show them. */
export const useLoginNotices = (app?: NoticeLoginApp, { brandId, enabled = true }: Options = {}) => {
  const ready = app != null && enabled;
  const { data, error, isFetching, refetch } = noddiAsync.useGet({
    type: URLKeys.getLoginNotices,
    input: {
      app: app ?? NoticeLoginApp.ADMIN,
      ...(brandId == null ? {} : { brandId })
    },
    queryConfig: {
      enabled: ready,
      staleTime: 60_000,
      refetchInterval: 5 * 60_000
    }
  });
  const notices = ready ? (data ?? []) : [];

  return {
    error: ready ? error : undefined,
    isFetching,
    refetch,
    ...splitNoticesByPlacement(notices)
  };
};
